import isMobile from 'ismobilejs';
export default class UsagiDetector {
	constructor( opts = {} ) {
		this.wrap = opts.wrap ? opts.wrap : document.querySelector('html');
		this.detect = {
			svg : opts.svg ? opts.svg : false,
			deviceChange : opts.deviceChange ? opts.deviceChange : false,
		}
		this.spec = {
			str   : null,
			score : 0,
		}
		this.reduced = false;
		this.webp    = true;
		this.touch   = false;
		this.retina  = false;
		this.webgl   = true;
		this.browser = null;
		this.legacy  = false;
		this.os = {
			win     : false,
			mac     : false,
			android : false,
			ios     : false,
			unknown : false
		}
		this.device = {
			mobile  : false,
			tablet  : false,
			ipadpro : false,
			desktop : false,
			laptop  : false,
			any     : false,
			history : {
				mobile  : false,
				tablet  : false,
				ipadpro : false,
				desktop : false,
				laptop  : false,
				any     : false
			}
		}
		this.mode = null;
		this.ua = window.navigator.userAgent.toLowerCase();
		this.ua_ver = window.navigator.appVersion.toLowerCase();
		this.onInit();
	}
	onInit(){
		if( window.ontouchstart === null) this.touch = true;
		if( window.navigator.platform.indexOf("Win") != -1 ) this.os.win = true;
		this.onDetectRetina();
		this.onDetectDevide();
		this.onDetectOs();
		this.onDetectSpec();
		this.onDetectBrows();
		this.onDetectWebGL();
		this.onDetectMotionReduced();
		this.onDetectColorMode();
		this.onDetectWebP();
		if( this.detect.deviceChange ) this.onDetectDeviceChange();
		if( this.detect.svg ) this.onDetectSvg();
		// this.wrap.dataset.reduced = this.reduced;
		// this.wrap.dataset.webgl = this.webgl;
		this.result = {
			'DETECT.ua' : this.ua,
			'DETECT.browser' : this.browser,
			'DETECT.legacy' : this.legacy,
			'DETECT.spec.str' : this.spec.str,
			'DETECT.os.win' : this.os.win,
			'DETECT.os.mac' : this.os.mac,
			'DETECT.spec.score' : this.spec.score,
			'DETECT.reduced' : this.reduced,
			'DETECT.webgl' : this.webgl,
			'DETECT.device.mobile' : this.device.mobile,
			'DETECT.device.desktop' : this.device.desktop,
			'DETECT.device.tablet' : this.device.tablet,
			'DETECT.touch' : this.touch,
			'DETECT.retina' : this.retina,
			'DETECT.mode' : this.mode,
			'DETECT.webp' : this.webp
		}
		console.table( this.result );
	}
	onDetectWebP(){
		const canvas = document.createElement('canvas');
		if (typeof document === 'object') {
			if ( canvas.getContext && canvas.getContext('2d') && canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0 ) {
				this.webp = true;
			} else {
				this.webp = false;
			}
		}
	}
	onDetectColorMode(){
		if( window.matchMedia ){
			if(window.matchMedia('(prefers-color-scheme: dark)').matches){
				this.mode = 'dark';
			} else {
				this.mode = 'light';
			}
		} else {
			this.mode = 'light';
		}
		// this.wrap.dataset.mode = this.mode;
	}
	onDetectRetina(){
		if( window.devicePixelRatio > 1 ){
			this.retina = true;
			// this.wrap.dataset.retina = true;
		}
	}
	onDetectSvg(){
		this.filter = {
			feDisplacementMap : false,
			feTurbulence : false
		}
		if( this.device.desktop ){
			switch( this.browser ){
				case 'chrome':
				case 'firefox':
				case 'ie11':
				case 'opera':
					this.filter.feDisplacementMap = true;
					this.filter.feTurbulence = true;
				break;
			}
		}
		// this.wrap.dataset.feDisplacementMap = this.filter.feDisplacementMap;
		// this.wrap.dataset.feTurbulence = this.filter.feTurbulence;
	}
	onDetectMotionReduced(){
		const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
		if( !mediaQuery || mediaQuery.matches ) {
			this.reduced = true;
		} else {
			this.reduced = false;
		}
	}
	onDetectWebGL(){
		const canvas = document.createElement('canvas');
		const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
		this.webgl = gl instanceof WebGLRenderingContext ? true : false;
		if( !this.webgl ) this.legacy = true;
	}
	onDetectDevide(){
		// console.log( isMobile(window.navigator.userAgent).phone );
		// if( this.legacy ){
		// 	this.device.any     = false;
		// 	this.device.mobile  = false;
		// 	this.device.tablet  = false;
		// 	this.device.desktop = true;
		// 	this.wrap.classList.add('is-not-any');
		// 	if( window.innerWidth <= 1366 ){
		// 		this.laptop = true;
		// 	}
		// } else
		if( isMobile(window.navigator.userAgent).phone || window.innerWidth < 640 ){
			this.device.any     = true;
			this.device.mobile  = true;
			this.device.tablet  = false;
			this.device.desktop = false;
			this.wrap.classList.add('is-any','is-mobile');
		} else if( isMobile(window.navigator.userAgent).tablet || window.innerWidth < 1024 || ( !this.getUA('ipad') && ( this.getUA('macintosh') && 'ontouchend' in document )) ){
			this.device.any     = true;
			this.device.mobile  = false;
			this.device.tablet  = true;
			this.device.desktop = false;
			this.wrap.classList.add('is-any','is-tablet');
			if( window.innerWidth > 1024 ){
				this.device.ipadpro = true;
				this.wrap.classList.add('is-large-tablet');
			}
		} else {
			this.device.any = false;
			this.device.mobile = false;
			this.device.tablet  = false;
			this.device.desktop = true;
			this.wrap.classList.add('is-not-any');
			if( window.innerWidth <= 1366 ){
				this.laptop = true;
			}
		}
	}
	getUA(str) {
		return window.navigator.userAgent.toLowerCase().indexOf(str) != -1;
	}
	onDetectOs(){
		if( this.ua.indexOf("windows nt") !== -1 ) {
			this.os.win = true;
		} else if( this.ua.indexOf("android") !== -1 ) {
			this.os.android = true;
		} else if( this.ua.indexOf("iphone") !== -1 || this.ua.indexOf("ipad") !== -1 ) {
			this.os.ios = true;
		} else if( this.ua.indexOf("mac os x") !== -1 ) {
			this.os.mac = true;
		} else {
			this.os.unknown = true;
		}
	}
	onDetectSpec(){
		if( this.retina ){
			this.spec.str = 'Laptop';
			this.spec.score = 7;
			if( window.screen.width <= 1680 && window.navigator.hardwareConcurrency >= 6 ){
				this.spec.str  = 'Laptop HiEnd, Corei5 or higher';
				this.spec.score = 8;
			}
			if( ( window.innerWidth === 1680 && window.screen.width === 1680 ) && window.navigator.hardwareConcurrency >= 6 ){
				this.spec.str  = 'Laptop MidEnd, 15 Fullscreen, Corei5 or higher';
				this.spec.score = 7;
			}
			if( ( window.screen.width === 1440 ) && window.navigator.hardwareConcurrency >= 6 ){
				this.spec.str  = 'Laptop MidEnd, 13 Fullscreen, Corei5 or higher';
				this.spec.score = 8;
			}
			if( window.screen.width > 1680 && window.navigator.hardwareConcurrency >= 6 ){
				this.spec.str  = 'Desktop MidEnd, Corei5 or higher';
				this.spec.score = 9;
			}
			if( window.screen.width > 1680 && window.navigator.hardwareConcurrency >= 8 ){
				this.spec.str  = 'Desktop HiEnd, Corei7 or higher';
				this.spec.score = 10;
			}
		} else {
			this.spec.str = 'Leagcy';
			this.spec.score = 8;
		}
		if( this.device.phone ){
			this.spec.str = 'Mobile';
		} else if( this.device.tablet ){
			this.spec.str = 'Tablet';
		}
	}
	onDetectBrows(){
		if (this.ua.indexOf('edge') !== -1){
			this.browser = "edge";
		} else if (this.ua.indexOf("iemobile") !== -1){
			this.browser = "iemobile";
			this.legacy  = true;
			this.webp = false;
		} else if (this.ua.indexOf('trident/7') !== -1){
			this.browser = "ie11";
			this.legacy  = true;
			this.webp = false;
		} else if (this.ua.indexOf("msie") !== -1 && this.ua.indexOf('opera') === -1) {
			this.legacy  = true;
			this.webp = false;
			if (this.ua_ver.indexOf("msie 6.")  !== -1){
				this.browser = "ie6";
			} else if (this.ua_ver.indexOf("msie 7.")  !== -1){
				this.browser = "ie7";
			} else if (this.ua_ver.indexOf("msie 8.")  !== -1){
				this.browser = "ie8";
			} else if (this.ua_ver.indexOf("msie 9.")  !== -1){
				this.browser = "ie9";
			} else if (this.ua_ver.indexOf("msie 10.") !== -1){
				this.browser = "ie10";
			}
		} else if (this.ua.indexOf('chrome')  !== -1 && this.ua.indexOf('edge') === -1){
			this.browser = "chrome";
		}else if (this.ua.indexOf('safari')  !== -1 && this.ua.indexOf('chrome') === -1){
			this.browser = "safari";
			if( !this.device.any ){
				this.legacy = true;
			}
		}else if (this.ua.indexOf('opera')   !== -1){
			this.browser = "opera";
		}else if (this.ua.indexOf('firefox') !== -1){
			this.browser = "firefox";
		}else{
			this.browser = "unknown";
		}
		if( this.legacy ){ this.wrap.classList.add('is-legacy') }
	}
	onDetectDeviceChange(){
		window.addEventListener('resize' , e =>{
			this.onResize();
		});
	}
	onResize(){
		this.device.history = {
			mobile  : this.device.mobile,
			tablet  : this.device.tablet,
			ipadpro : this.device.ipadpro,
			desktop : this.device.desktop,
			laptop  : this.device.laptop,
			any     : this.device.any 
		}
		this.onDetectDevide();
		let count = 0;
		Object.keys( this.device.history ).forEach( (k) => {
			if( this.device.history[k] != this.device[k] ){
				count++;
			}
		});
		if( count != 0 ){
			location.reload();
		}
	}
}